import React from "react";
import { Fragment } from "react";

const Copyright = () => {
  const currentYear = new Date().getFullYear();
  return <Fragment>© 2020 - {currentYear}</Fragment>;
};

export default Copyright;
